import React, { useEffect, useState } from "react";

import PanelTemplate from "../../templates/Panel";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import PageHeader from "../../components/PageHeader";
import FilterAndPaginate from "../../components/FilterAndPaginate";
import DotColor from "../../components/DotColor";
import Input from "../../components/Input";
import InputSelect from "../../components/InputSelect";
import InputColor from "../../components/InputColor";
import InputFile from "../../components/InputFile";
import { renderError } from "../../helpers/errors";
import api from "../../services/api";
import { toast } from "react-toastify";
import { splitArray } from "../../helpers/conversions";
import { Loading } from "../../components/Loading";
import { ModalDelete } from "../../components/ModalDelete";

const types = [
    {label: 'Imagem', value: 'image'},
    {label: 'Cor', value: 'hexadecimal'}
];

export const ColorList = () => {
    const [loading, setLoading] = useState(false);

    const [filters, setFilters] = useState('');

    const [colorToDelete, setColorToDelete] = useState(null);

    const [colors, setColors] = useState([]);
    const [colorId, setColorId] = useState(null);
    const [colorName, setColorName] = useState('');
    const [colorHexadecimal, setColorHexadecimal] = useState('');
    const [colorSku, setColorSku] = useState('');
    const [colorType, setColorType] = useState('');

    const [colorImageBase64, setColorImageBase64] = useState('');
    const [colorImageName, setColorImageName] = useState('');

    const [showCreateColor, setShowCreateColor] = useState(false);
    const [showEditColor, setShowEditColor] = useState(false);    

    useEffect(() => {
        getColors();
    }, [filters]);

    const cleanColor = () => {
        setColorId(null);
        setColorName('');
        setColorHexadecimal('');
        setColorSku('');
        setColorImageName('');
        setColorType('');
    }

    const getColors = () => {
        setColors([]);
        setLoading(false);

        api.get(`/color?${filters}`).then(res => {
            let resource = res.data.resources;
            
            setColors(resource);
        }).catch(error => {
            renderError(error);
            setLoading(false);
        }).then(() => setLoading(false));
    }

    const storeColor = () => {
        setLoading(true);

        let data = {
            name: colorName,
            sku: colorSku,
            type: colorType
        };

        if(colorType === 'hexadecimal'){
            data.hexadecimal = colorHexadecimal;
        }
        if(colorType === 'image'){
            data.image = colorImageBase64;
        }

        api.post(`/color`, data).then(res => {
            toast.success('Cor cadastrada com sucesso');
            handleCloseModal();
            getColors();
        }).catch(error => {
            renderError(error);
            setLoading(false);
        }).then(() => setLoading(false));
    }

    const updateColor = () => {
        setLoading(true);

        let data = {
            name: colorName,
            sku: colorSku,
            type: colorType
        }

        if(colorType === 'hexadecimal'){
            data.hexadecimal = colorHexadecimal;
        }
        if(colorType === 'image'){
            data.image = colorImageBase64;
        }

        api.put(`/color/${colorId}`, data).then(res => {
            toast.success('Cor atualizada com sucesso');
            handleCloseModal();
            getColors();        
        }).catch(error => {
            renderError(error);
            setLoading(false);
        }).then(() => setLoading(false));
    }

    const editColor = color => {
        setColorId(color.id);
        setColorName(color.name);
        setColorHexadecimal(color.hexadecimal);
        setColorSku(color.sku);
        setColorType(color.type);
        setColorImageName(color.image);
        setShowEditColor(true);
    }

    const deleteColor = () => {
        setLoading(true);
        
        api.delete(`/color/${colorToDelete}`).then(res => {
            toast.success('Cor deletada com sucesso');
            handleCloseModal();
            getColors();
        }).catch(error => {
            renderError(error);
            setLoading(false);
        }).then(() => setLoading(false));
    }
    
    const handleCloseModal = () => {
        cleanColor();
        setShowCreateColor(false)
        setShowEditColor(false)
        setColorToDelete(null)
    }

    const Color = ({color}) => {    
        return (         
            <div className="group">
                <li className={`color`}>
                    <div className="color-desc">
                        <DotColor size={20} color={color.hexadecimal} image={color.image_url?.small} type={color.type} />
                        <span>{color.name}</span>
                    </div>
                    <div className="color-sku">
                        <span>{color.sku}</span>
                    </div>                
                        <button className="action action-edit" title="Editar cor" onClick={() => editColor(color)}><Icon name="edit" size={16} /></button>
                        <button className="action action-delete" title="Excluir cor" onClick={() => setColorToDelete(color.id)}><Icon name="delete" size={16} /></button>
                </li>
            </div> 
        )
    }

    return (
        <>
            <ModalDelete 
                        show={colorToDelete !== null}
                        action={deleteColor}
                        close={handleCloseModal}
                        loading={loading}
                    />            
            <Modal
                title={`Cadastrar cor`}
                show={showCreateColor}
                close={handleCloseModal}
                footer={
                    <Button 
                        type={`primary`}
                        size={`small`}
                        text={`Cadastrar`}
                        svg={`save-white`}
                        action={storeColor}
                        loading={loading}
                    />
                }
            >
                <div className="section">
                    <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Nome`} change={setColorName} value={colorName} />
                        </div>
                        <div className="col-6">
                            <InputSelect label={`Tipo`} value={colorType} change={setColorType} options={types} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`SKU`} change={setColorSku} value={colorSku} />
                        </div>
                        <div className="col-6">
                            {colorType === 'hexadecimal' &&
                                <InputColor label={`Cor`} value={colorHexadecimal} change={setColorHexadecimal} />
                            }
                            {colorType === 'image' &&
                                <InputFile 
                                    label={`Imagem`} 
                                    base64={colorImageBase64}
                                    changeBase64={setColorImageBase64}
                                    name={colorImageName}
                                    changeName={setColorImageName}
                                    description={`Tamanho ideal: 80px por 80px`}
                                />
                            }
                        </div>
                    </div>                  
                </div>
            </Modal>
            <Modal
                title={`Editar cor`}
                show={showEditColor}
                close={handleCloseModal}
                footer={
                    <Button 
                        type={`primary`}
                        size={`small`}
                        text={`Salvar alterações`}
                        svg={`save-white`}
                        action={updateColor}
                        loading={loading}
                    />
                }
            >
                <div className="section">
                    <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Nome`} change={setColorName} value={colorName} />
                        </div>
                        <div className="col-6">
                            <InputSelect label={`Tipo`} value={colorType} change={setColorType} options={types} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`SKU`} change={setColorSku} value={colorSku} />
                        </div>
                        <div className="col-6">
                            {colorType === 'hexadecimal' &&
                                <InputColor label={`Cor`} value={colorHexadecimal} change={setColorHexadecimal} />
                            }
                            {colorType === 'image' &&
                                <InputFile 
                                    label={`Imagem`} 
                                    base64={colorImageBase64}
                                    changeBase64={setColorImageBase64}
                                    name={colorImageName}
                                    changeName={setColorImageName}
                                    description={`Tamanho ideal: 80px por 80px`}
                                />
                            }
                        </div>
                    </div>               
                </div>
            </Modal>
            <PanelTemplate id="color-list">
                <PageHeader
                    left={
                        <FilterAndPaginate 
                            params={[
                                {name: 'Nome', key: '[name]', type: 'text' }
                            ]}
                            filter={setFilters}
                        />
                    }

                    right={
                        <>
                            {
                                <Button type={`primary`} size={`small`} text={`Cadastrar nova cor`} svg="plus-white" action={() => setShowCreateColor(true)} />
                            }
                        </>
                    }
                />
                <Loading show={loading} />
                <div className="row">
                    <div className="col-4">
                        <div className="groups">
                            <ul>
                                {splitArray(colors, 3, 0).map((color, index) => (
                                    <Color key={index} color={color} />
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="groups">
                            <ul>
                                {splitArray(colors, 3, 1).map((color, index) => (
                                    <Color key={index} color={color} />
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="groups">
                            <ul>
                                {splitArray(colors, 3, 2).map((color, index) => (
                                    <Color key={index} color={color} />
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>            
            </PanelTemplate>
        </>
    );
}

export default ColorList;